module.exports = __webpack_public_path__ + "media/3.bb269753.mp3";